import React from 'react';
import { connect } from 'react-redux';
import colors from '@app/constants/colors';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import RouterConstants from '@app/constants/router';
import { Button } from '@app/components';
import { subscribeSelectedOption } from '@app/actions/subscribeActions';

const SignUpConfirmSuccess = ({ history, subscribeSelectedOption, isPurchaseInProgress }) => (
  <React.Fragment>
    <h1><FormattedMessage id="signUp.confirmation.congratulation" /></h1>
    <h2><FormattedMessage id="signUp.confirmation.validationSucceeded" /></h2>
    <ButtonsContainer>
      <Button
        labelId="subscribe.button.back"
        textColor={colors.ALICE_BLUE}
        backgroundColor={colors.INTERNATIONAL_ORANGE}
        disabled={isPurchaseInProgress}
        onClick={() => history.push(RouterConstants.SUBSCRIBE)}
      />
      <Button
        labelId="subscribe.button.next"
        textColor={colors.ALICE_BLUE}
        backgroundColor={colors.INTERNATIONAL_ORANGE}
        loading={isPurchaseInProgress}
        disabled={isPurchaseInProgress}
        onClick={subscribeSelectedOption}
      />
    </ButtonsContainer>
  </React.Fragment>
);

const mapStateToProps = ({
  subscribe: { isPurchaseInProgress },
}) => ({
  isPurchaseInProgress,
});

export default withRouter(connect(mapStateToProps, { subscribeSelectedOption })(SignUpConfirmSuccess));

SignUpConfirmSuccess.propTypes = {
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
  subscribeSelectedOption: PropTypes.func.isRequired,
  isPurchaseInProgress: PropTypes.bool.isRequired,
};

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 50px;
  @media (max-width: 979px) {
    margin-top: 30px;
  }
`;
